import { TablePagination, Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses, TableContainer } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import Consulta from './Consulta';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

let filasTotales = 0;
const opcionesFilasPorPagina = [5, 10, 25, 50, 100];


class Medicos extends Component {
    constructor(props){
        super(props);
        this.state = {
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            informesAListar: [],
            //------------------

            numeroNombre: [],
            errores: null,
            notificaciones: null,
            loading: false,
            consulta: false,
            busqueda: {
                tipoConsulta: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
            },
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarEnvioEliminar = this.manejarEnvioEliminar.bind(this);
        this.manejoEnvioAgregarMedico = this.manejoEnvioAgregarMedico.bind(this);
        this.manejarAtrasConsulta = this.manejarAtrasConsulta.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.informesAListar.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };

    render(){
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.informesAListar.length;
        return (
            <>
                {!sessionStorage.login
                ?
                    <Redirect to='/login'/>
                :
                    null
                }
                <h3>Médicos</h3>
                {this.state.notificacionesEnvio ? (<div className="alert alert-success" > {this.state.notificacionesEnvio}</div>) : null}
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consulta
                ?
                    <Container >
                        <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{maxWidth: '100%'}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Número</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Nombre</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.informesAListar.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                        <StyledTableRow key={name.idFuncionario}>
                                            <StyledTableCell style={{textAlign: 'center'}}>{name.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>{name.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarEnvioEliminar(name)}>Eliminar</button></StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                        </TableContainer>
                        <button style={{marginTop: '1rem'}} className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarAtrasConsulta}>Volver</button>
                    </Container>
                :
                    <Container>
                        <TableContainer style={{width: '60%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Número</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Nombre</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell  style={{textAlign: 'center'}}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8", textAlign: 'center'}} id='tipoConsulta'  value={this.state.busqueda.tipoConsulta} onChange={this.manejarCambiosDatos}>
                                                <option value=''></option>
                                                <option value={1}>CONSULTAR LISTA</option>
                                                <option value={2}>AGREGAR MEDICO</option>
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.busqueda.nombreFuncionario}</StyledTableCell>
                                        {this.state.busqueda.tipoConsulta === '' || this.state.busqueda.tipoConsulta === '1' ? <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell> : null}
                                        {this.state.busqueda.tipoConsulta === '2' ? <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioAgregarMedico()}>Agregar</button></StyledTableCell> : null}
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                }
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            notificacionesEnvio: null,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if(clave === 'numeroFuncionario'){
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(e){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        const cargaUtil = JSON.stringify([this.state.busqueda]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_medicos.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                consulta: true,
                informesAListar: exito[1],
            })
        }
    }

    async manejarEnvioEliminar(dato){

        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        const cargaUtil = JSON.stringify([dato]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/eliminar_medicoLista.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Eliminado correctamente',
                informesAListar: [],
                consulta: false,
            });

            this.manejoEnvioConsulta();
        }
    }

    async manejoEnvioAgregarMedico(e){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        const cargaUtil = JSON.stringify([this.state.busqueda]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_medicoLista.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Datos ingresados orrectamente',
            })

            this.setState(state => {
                const numFunActualizado = state.busqueda;
                numFunActualizado['numeroFuncionario'] = '';
                numFunActualizado['nombreFuncionario'] = '';
                
                return{
                    busqueda: numFunActualizado,
                };
            });
        }
    }

    manejarAtrasConsulta(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            errores: null,
            notificaciones: null,
            informesAListar: [],
        })
    }
}

export default Medicos